var _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 265 48",
    width: 265,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fontSize: 18,
    fontWeight: "bold",
    x: 5,
    y: 35
  }, "Super Nova")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fill: "black",
    fontSize: 10,
    fontWeight: "normal",
    x: 5,
    y: 60
  }, "snova.me")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e9b57ce5ad7970d8cde108e3f257cd4d.svg";
export { ForwardRef as ReactComponent };